export const valoresExibidosFaq: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  teste: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorObservacoes: '',

  //Específicos
  topicoComunicacao: 'Tópico da Comunicação',
  contexto: 'Contexto',
  respostaEncaminhamento: 'Resposta/Encaminhamento',
};

export const headersFaq = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Tópico', width: 15, key: 'topicoComunicacao' },
  { text: 'Contexto', width: 20, key: 'contexto' },
  { text: 'Resposta', width: 35, key: 'respostaEncaminhamento' },
];

export const fieldObjectFaq = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
